module.exports = __webpack_public_path__ + "static/img/share-sheet-weibo.05f3bb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/share-sheet-weibo.png
// module id = hjsg
// module chunks = 3